/**
 * Widget Size Configurations
 * Contains default size constraints for each widget type
 */

import { DEFAULT_FALLBACK_SIZES } from './constants';

/**
 * Default sizes for each widget type
 */
export const widgetSizes = {
  kpi: {
    minW: 2,
    minH: 2,
    defaultW: 3,
    defaultH: 2
  },

  table: {
    minW: 4,
    minH: 3,
    defaultW: 10,
    defaultH: 4
  },

  areachart: {
    minW: 4,
    minH: 3,
    defaultW: 6,
    defaultH: 4
  },

  barchart: {
    minW: 4,
    minH: 3,
    defaultW: 4,
    defaultH: 4
  },

  donutchart: {
    minW: 4,
    minH: 3,
    defaultW: 6,
    defaultH: 4
  },

  sectionbreak: {
    minW: 12,
    minH: 1,
    defaultW: 12,
    defaultH: 1
  },

  forecastchart: {
    minW: 6,
    minH: 4,
    defaultW: 8,
    defaultH: 5
  },

  forecasttable: {
    minW: 6,
    minH: 4,
    defaultW: 10,
    defaultH: 5
  },

  resourcechangestrend: {
    minW: 6,
    minH: 4,
    defaultW: 6,
    defaultH: 5
  },

  resourcechangesoverview: {
    minW: 4,
    minH: 2,
    defaultW: 6,
    defaultH: 2
  },

  resourceoverview: {
    minW: 4,
    minH: 2,
    defaultW: 6,
    defaultH: 2
  },

  resourcelist: {
    minW: 6,
    minH: 4,
    defaultW: 8,
    defaultH: 6
  },

  resourceutilization: {
    minW: 4,
    minH: 3,
    defaultW: 6,
    defaultH: 4
  },

  insighttable: {
    minW: 6,
    minH: 4,
    defaultW: 10,
    defaultH: 6
  },

  costtrendchart: {
    minW: 4,
    minH: 3,
    defaultW: 6,
    defaultH: 5
  }
};

/**
 * Get default sizes for a widget type
 * @param {string} type - Widget type
 * @returns {Object} - Default sizes
 */
export const getDefaultSizes = (type) => {
  return widgetSizes[type] ? { ...widgetSizes[type] } : { ...DEFAULT_FALLBACK_SIZES };
};

export default widgetSizes;

